import { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { OnboardingTour } from './OnboardingTour';
import { useGamification } from '@/hooks/useGamification';

const ONBOARDING_STORAGE_KEY = 'jewmap_onboarding_done';

export const OnboardingWrapper = () => {
  const { user, loading: authLoading } = useAuth();
  const { unlockBadge } = useGamification();
  const [showOnboarding, setShowOnboarding] = useState(false);

  useEffect(() => {
    // Only check once auth is loaded and we have a user
    if (authLoading) return;
    
    if (user) {
      const onboardingDone = localStorage.getItem(ONBOARDING_STORAGE_KEY);
      if (!onboardingDone) {
        // Small delay to ensure smooth transition after any splash/login
        setTimeout(() => setShowOnboarding(true), 500);
      }
    }
  }, [user, authLoading]);

  const handleComplete = async (completed: boolean) => {
    // Always mark onboarding as done
    localStorage.setItem(ONBOARDING_STORAGE_KEY, 'true');
    setShowOnboarding(false);

    // Only award badge if user completed (didn't skip)
    if (completed && user) {
      await unlockBadge('welcome');
    }
  };

  if (!showOnboarding) return null;

  return <OnboardingTour open={showOnboarding} onComplete={handleComplete} />;
};
